import styled from 'styled-components';
import { Spinner } from '../../icons';
import colors from '../../utils/colors';
import { radii, outlines } from '../../utils/theme';
import typography from '../../utils/typography';
const { display6 } = typography;
const { sky, sunrise, sunriseLighter, midnight, lightGrey, grey, blend, meld, white, fuse } = colors;
const getButtonVariantStyles = (variant) => {
    switch (variant) {
        case 'primary':
            return {
                borderColor: 'transparent',
                backgroundColor: sunrise,
                '&:hover': { backgroundColor: sunriseLighter },
            };
        case 'secondary':
            return {
                borderColor: 'transparent',
                backgroundColor: sky,
                '&:hover': { backgroundColor: fuse },
            };
        case 'tertiary':
            return {
                borderColor: midnight,
                backgroundColor: white,
                '&:hover': { backgroundColor: lightGrey },
            };
        case 'clear':
            return {
                borderColor: 'transparent',
                backgroundColor: 'transparent',
                '&:hover': { backgroundColor: blend },
            };
    }
};
const getButtonPadding = (size) => {
    switch (size) {
        case 'sm':
            return '0.5rem 1.75rem';
        case 'md':
            return '0.75rem 1.75rem';
        case 'lg':
            return '1rem 1.75rem';
    }
};
export const StyledButton = styled.button.withConfig({
    shouldForwardProp: (prop) => !['variant', 'size', 'fullWidth', 'iconPosition', 'loading'].includes(prop),
})(({ variant, size, fullWidth, iconPosition, loading }) => [
    display6,
    {
        boxSizing: 'border-box',
        position: 'relative',
        display: 'inline-flex',
        padding: getButtonPadding(size),
        width: fullWidth ? '100%' : 'auto',
        borderRadius: radii.default,
        transition: 'background-color 0.2s ease',
        cursor: 'pointer',
        border: '2px solid',
        color: midnight,
        textDecoration: 'none',
        '&:active': {
            textDecoration: 'underline',
        },
        '&:focus-visible': {
            outlineOffset: '1px',
            outline: outlines.focus,
        },
        '&[disabled]': loading
            ? {
                cursor: 'progress',
                ...getButtonVariantStyles(variant)?.['&:hover'],
            }
            : {
                backgroundColor: grey,
                color: meld,
                cursor: 'not-allowed',
                textDecoration: 'none',
                borderColor: 'transparent',
                '&:hover': { backgroundColor: grey },
            },
        svg: {
            order: iconPosition === 'right' ? '1' : '0',
        },
    },
    getButtonVariantStyles(variant),
]);
export const StyledContent = styled.span({
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '0.5rem',
    width: '100%',
    svg: { height: '1rem' },
});
export const StyledSpinner = styled(Spinner)({
    height: '1.25rem',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    color: midnight,
});
